import { IAudioDriver } from './AudioService'

export class WebDriver implements IAudioDriver {
  sounds: Record<string, HTMLAudioElement> = {}

  load(path: string): void {
    const sound = new Audio(path)
    this.sounds[path] = sound
  }

  play(fileId: string): void {
    this.sounds[fileId].play()
  }

  pause(fileId: string): void {
    this.sounds[fileId].pause()
  }

  stop(fileId: string): void {
    this.sounds[fileId].pause()
    this.sounds[fileId].currentTime = 0
  }
}
